import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';
import Card from 'material-ui/Card';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import userStore from '../../stores/UserStore';

/**
 * Receives sessionid and uid props from simulationContainer
 *
 * this component acts as the simulationContainer for all
 * components in the actual orderbook.
 */
class DealerBox extends Component {
    constructor(props) {
        //console.log("OrderbookContainer created");
        super(props);
    }

    renderDealerUser(props){
        console.log('RENDERING DEALERS');
        return (
            <Card className={((this.props.player.id == userStore.uid) ? `active dealerBoxStyle box-${this.props.player.cssClass}` : `dealerBoxStyle box-${this.props.player.cssClass}`)}>
              <h5><span className={"playername "+this.props.columnType}>{this.props.player.name}</span> <span className={"price " + this.props.columnType}>{this.props.player.price}</span></h5>
              <h6 className={"position "+ (this.props.showPos || 'hide')}>{this.props.player.position}</h6>
            </Card>
        );
    }

    renderMarketUser(props){
        console.log('RENDERING MARKET USERS');
        return (
            <div></div>
        );
    }

    renderCorrectUser(props){
        console.log('RENDERING CORRECT USERS');
        const isDealer = props.isDealer;
        if(isDealer){
            return (<renderDealerUser/>);
        }
        else{
            return (<renderMarketUser/>);
        }
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }

    /**
     * Conditionally renders limit orders based on state.ready
     * @returns {*}
     */
    render() {
        //console.log("OrderbookContainer render");
        //console.log(this.state.userSums);
        return (
            <Card className={((this.props.player.id == userStore.uid) ? `active dealerBoxStyle box-${this.props.player.cssClass}` : `dealerBoxStyle box-${this.props.player.cssClass}`)}>
              <h5><span className={"playername "+this.props.columnType}>{this.props.player.name}</span> <span className={"price " + this.props.columnType}>{this.props.player.price}</span></h5>
              <h6 className={"position "+ (this.props.showPos || 'hide')}>{this.props.player.position}</h6>
            </Card>
        );
    }
}

export default DealerBox;



// WEBPACK FOOTER //
// ./src/components/Orderbook/DealerBox.js